const signIndex = [
  {
    path: '/',
    name: 'sign-index',
    meta: {
      title: ''
    },
    component: resolve => require(['@/page/sign/index.vue'], resolve)
  },
  {
    path: '/sign-index',
    name: 'sign-index',
    meta: {
      title: ''
    },
    component: resolve => require(['@/page/sign/index.vue'], resolve)
  }
]
export default signIndex



// WEBPACK FOOTER //
// ./src/router/sign-index.js